const textFieldUserMyAccount = {
  nameHelp: 'Ingrese su nombre completo',
  password: 'Contraseña Actual',
  passwordNew: 'Nueva Contraseña',
  passwordError: 'Mínimo de 6 caracteres',
  passwordNew2: 'Repita la nueva contraseña',
  PasswordNewError2: 'Contraseñas diferentes'
};

export default textFieldUserMyAccount;
